import { HttpParams } from '@angular/common/http';
import { Component, NgZone, OnInit } from '@angular/core';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-progress-modal',
  templateUrl: './progress-modal.component.html'
})
export class ProgressModalComponent implements OnInit {

  data: any;
  finalData: any;
  progress: number = 0;
  max: number = 100;
  private sseSubscription: Subscription;

  constructor(private modal: NgxSmartModalComponent, private zone: NgZone) { }

  ngOnInit() {
    this.data = this.modal.getData();
    this.listenToProgress(this.data.url, this.data.params);
  }

  ngOnDestroy() {
    if (this.sseSubscription) {
      this.sseSubscription.unsubscribe();
    }
  }

  private listenToProgress(url: string, params: any) {
    if (params) {
      const httpParams = new HttpParams({ fromObject: params })
      url = `${url}?${httpParams.toString()}`
    }

    this.sseSubscription = this.createSseObservable(`${environment.apiUrl}${url}`).subscribe({
      next: data => this.updateProgress(data),
      error: error => this.handleError(error),
      complete: () => this.handleComplete()
    });
  }

  private createSseObservable(url: string): Observable<any> {
    return new Observable<any>(observer => {
      const eventSource = new EventSource(url);

      eventSource.onmessage = event => {
        this.zone.run(() => {
          const data = JSON.parse(event.data);
          observer.next(data);
          if (data.final) {
            this.finalData = data;
            eventSource.close();
            observer.complete();
          }
        });
      };

      eventSource.onerror = error => {
        console.error('EventSource failed:', error);
        this.zone.run(() => {
          observer.error('An error occurred');
        });
        eventSource.close();
      };

      return () => eventSource.close();
    });
  }

  private updateProgress(data: any) {
    //console.log(data);
    if (data.max)
      this.max = data.max;
    if (data.progress)
      this.progress = data.progress;
  }

  private handleError(error: any) {
    console.error('EventSource failed:', error);
    this.modal.close();
  }

  private handleComplete() {
    console.log('Stream complete');
    if (this.finalData)
      this.modal.setData({ result: this.finalData }, true)
    this.modal.close();
  }
}